<div id="services-popup" class="common-popup-block-doc">
    <div class="popoup-hearder">
        <h2 class="m-b-5" mat-dialog-title>Nombre del formato</h2>
    </div>
    <div class="popoup-content">
        <div class="block-looper-wrapper">
            <div class="block-looper">
                <div class="form-wrap">
                    <div mat-dialog-content>
                        <!-- <mat-label>Nombre del formato</mat-label> -->
                        <input matInput type="text" [formControl]="nombre">
                        <mat-error *ngIf="invalid">
                            <span class="validation-span">Obligatorio</span>
                          </mat-error>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="popoup-footer">
        <button class="keep" (click)="saveFormato()"><span class="mat-button-wrapper">Guardar</span></button>
        <button class="cancel" (click)="cancel()"><span class="mat-button-wrapper">Cancelar</span></button>
    </div>
</div>